// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';
import Form from './Form';

const initialValues = {
    name: '',
    ext: '',
    data: '',
};

const initialErrors = {
    name: '',
    ext: '',
    data: '',
};

let abortController;

const DialogEdit = (props) => {
    const [loading, setLoading] = useState(true);
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    const fetch = (abortController) => {
        props.fetch.get(`/api/files/text/${props.selectedFile.id}/`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setValues({...values, data: data.data});
                }
                setLoading(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            });
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        let _abortController = new AbortController();
        if (props.open) {
            setLoading(true);
            fetch(_abortController);
        }
        return () => {
            _abortController.abort();
        };
    }, [props.open]);

    useEffect(() => {
        if (props.selectedFile) {
            setValues({
                name: props.selectedFile.name,
                ext: props.selectedFile.ext,
                data: ''
            });
        }
    }, [props.selectedFile]);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.put(`/api/files/text/${props.selectedFile.id}/`, values, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    clear();
                    props.onOk(data);
                }
                else {
                    let _errors = {...initialErrors};
                    _errors.name = (data.name) ? data.name[0] : '';
                    _errors.ext = (data.ext) ? data.ext[0] : '';
                    _errors.data = (data.data) ? data.data[0] : '';
                    setErrors(_errors);
                }
                setFetching(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setFetching(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
        props.setSelectedFile(null);
    };

    return (
        <DialogForm id="files-dialog-edit" title="Изменение файла" label="Изменить"
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    loading={loading} disabled={fetching}
        >
            <Form values={values} onChange={handleChange} errors={errors} onFocus={handleFocus}/>
        </DialogForm>
    );
};

DialogEdit.propTypes = {
    selectedFile: PropTypes.object,
    setSelectedFile: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogEdit;
Component = withFetch(Component);

export default Component;
